import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import api from "@/lib/api";
import { X } from "lucide-react";

export default function NewsletterPopup() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem("ie_newsletter_seen");
    if (seen) return;
    const t = setTimeout(() => setOpen(true), 18000);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    localStorage.setItem("ie_newsletter_seen", "1");
    setOpen(false);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return toast.error("Please enter a valid email");
    setSubmitting(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Welcome to the atelier", { description: "Watch for our private editions." });
      close();
    } catch {
      toast.error("Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && close()}>
      <DialogContent className="max-w-2xl p-0 border-border bg-surface" data-testid="newsletter-popup">
        {/* <button onClick={close} aria-label="close" data-testid="newsletter-close" className="absolute top-4 right-4 z-10 p-2 hover:opacity-60 transition-opacity">
          <X className="w-4 h-4" />
        </button> */}
        <div className="grid md:grid-cols-2">
          <div className="aspect-[4/5] md:aspect-auto bg-cover bg-center hidden md:block" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1483985988355-763728e1935b?w=900&q=80')" }} />
          <div className="p-10 md:p-12">
            <DialogHeader>
              <div className="ie-overline text-brand-accent mb-4">First Look</div>
              <DialogTitle className="font-serif text-3xl md:text-4xl leading-tight tracking-tight">
                Receive 10% off<br/>your first edition.
              </DialogTitle>
            </DialogHeader>
            <p className="text-sm text-text-secondary mt-4 leading-relaxed">
              Quietly worn news from the atelier — private editions, slow stories, no noise.
            </p>
            <form onSubmit={submit} className="mt-8 space-y-6">
              <input
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="ie-input"
                data-testid="newsletter-email-input"
                required
              />
              <button type="submit" disabled={submitting} className="ie-btn-primary w-full" data-testid="newsletter-submit">
                {submitting ? "Joining…" : "Join the Atelier"}
              </button>
            </form>
            <p className="text-[10px] tracking-[0.2em] uppercase text-text-secondary mt-6">
              No noise. Unsubscribe anytime.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
